import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";


const fetchPaymentDetails = async (applicationDetails, setter, setLoading) => {
  const { applicationId, businessAreaDispValue } = applicationDetails;

  const url = `${endpoint.getFeeBreakupWithPaymentDetails}/${applicationId}?businessArea=${businessAreaDispValue}`;
  try {
    setLoading(true);
    const response = await fetchAllPromisedData(url, true);
    if (response?.data) {
      setter(response?.data);
    } else {
      setter(null);
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
  }
};

export const useFetchPaymentDetails = (applicationDetails) => {
  const [isLoading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});

  useEffect(() => {
    if (applicationDetails)
      fetchPaymentDetails(applicationDetails, setPaymentDetails, setLoading);
  }, [applicationDetails]);

  return [paymentDetails, isLoading];
};


export const useNavigateToGivenPath = (defaultPath) => {
  const history = useHistory();

  return (path) => {
    window.open(
      history.createHref({
        pathname: path ?? defaultPath,
      })
    );
  };
}
const getInstallmentWiseReceiptMapping=(receiptData)=>{

  const receiptMap = {};
  for (const item of receiptData) {
  const key = item.minimumItemType;
  if (!receiptMap[key]) {
    receiptMap[key] = [];
  }
  receiptMap[key].push(...item.receiptLevelDetailsDTOList);
}
return receiptMap
}

const fetchInstallmentwiseReceipt= async(applicationDetails,setter, setLoading)=>{
    const { applicationId, businessAreaDispValue,psid } = applicationDetails;
  const url = `${endpoint.manageReceipts.viewReceiptsInstallmentWise}/${applicationId}?psid=${psid}&businessArea=${businessAreaDispValue}`;
  try {
    setLoading(true);
    const response = await fetchAllPromisedData(url, true);
    if (response?.data) {
      const installmentReceiptMapping= getInstallmentWiseReceiptMapping(response?.data)
      setter(installmentReceiptMapping);
    } else {
      setter(null);
    }
    setLoading(false);
  } catch (error) {
    setLoading(false);
  }
}

export const useInstallmentwiseReceipt=(applicationDetails)=>{
    const [isLoader, setLoading] = useState(false);
  const [installmentwiseReceiptMapping, setinstallmentwiseReceiptMapping] = useState({});

  useEffect(() => {
    if (applicationDetails)
      fetchInstallmentwiseReceipt(applicationDetails, setinstallmentwiseReceiptMapping, setLoading);
  }, [applicationDetails]);

  return [installmentwiseReceiptMapping, isLoader];
}
